export default __webpack_public_path__ + "static/media/wegzeit_bus.15430b86.svg";